@if (pending()) {
  <div class="join-approval">
    <mat-spinner diameter="32"></mat-spinner>
    <span class="join-approval__label">{{ reason() | translate }}</span>
    <andor-button (click)="cancel()">
      <span>{{ 'Cancel' | translate }}</span>
    </andor-button>
  </div>
}
